import { useEffect, useState } from "react";
import { useAPI } from "../../../../api/useAPI";
import {
  OrderScriptLogAnalysisResult,
  parseOrderScriptLogs,
} from "./parseOrderScriptLogs";
import { CreateCSVLogAnalysisResult, parseCreateCSVLogs } from "./parseCreateCSVLogs";

export const useAnalyseLogs = () => {
  const [analysisOS, setAnalysisOS] = useState<OrderScriptLogAnalysisResult>();
  const [analysisCCSV, setAnalysisCCSV] = useState<CreateCSVLogAnalysisResult>();
  const { getLogsContent } = useAPI();

  useEffect(() => {
    getLogsContent("CreateCSV_hl").then((response) => {
      if (response.success) {
        console.log(response.data);
        setAnalysisCCSV(parseCreateCSVLogs(response.data.content));
        return;
      }
      console.log("Error: " + response.error);
      alert("Error: " + response.error);
    });

    getLogsContent("order-script_hl").then((response) => {
      if (response.success) {
        console.log(response.data);
        setAnalysisOS(parseOrderScriptLogs(response.data.content));
        return;
      }
      console.log("Error: " + response.error);
      alert("Error: " + response.error);
    });
  }, []);

  return { analysisOS, analysisCCSV };
};
